import { Link } from 'react-router-dom'

/**
 * Unknown ≠ zero (data-truth rule #2). Missing data renders as "—" plus a
 * "not instrumented" link into the data-coverage meter — never a bare 0 or a
 * silently green default.
 */
export function UnknownValue({
  gapHref = '/fleet#blindness',
  reason,
}: {
  /** Deep link into the data-coverage meter for the gap that produced this unknown. */
  gapHref?: string
  reason?: string
}) {
  return (
    <span className="inline-flex items-center gap-1.5" title={reason}>
      <span className="mono text-unknown">—</span>
      <Link to={gapHref} className="text-[11px] font-medium text-unknown underline decoration-dotted">
        not instrumented
      </Link>
    </span>
  )
}
